import {Injectable, signal, WritableSignal} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Feature, GeoJsonObject, MultiPolygon, Polygon} from "geojson";
import {Observable} from "rxjs";
import {environment} from "../../../../../../environments/environment.development";
const apiVucUrl = environment.apiVucUrl
@Injectable({
  providedIn: 'root'
})
export class GeoMapService {
    datosCargado: WritableSignal<Boolean> = signal(false);
  constructor(private http: HttpClient) { }

    cargarGeoJSON(): Observable<GeoJsonObject> {
        return this.http.get<GeoJsonObject>('assets/json/geoJsonDemo.json');
    }

    getGeoTerritorioDot(): Observable<Feature<Polygon | MultiPolygon>[]> {
        const url = apiVucUrl + `api/v1.0/geo-territorio-dot/map-regulado`;
        return this.http.get<Feature<Polygon | MultiPolygon>[]>(url);
    }
    getGeoPoligonos(regulados:string[]): Observable<Feature<Polygon | MultiPolygon>[]> {
        const url = apiVucUrl + `api/v1.0/geo-municipio-poligono?regulados=${regulados}`;
        return this.http.get<Feature<Polygon | MultiPolygon>[]>(url);
    }
}
